import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Mevcut çeviriler
import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';

// Yeni eklenecek dillerin çevirileri
import translationAR from './locales/ar/translation.json'; // Arapça
import translationDE from './locales/de/translation.json'; // Almanca
import translationFR from './locales/fr/translation.json'; // Fransızca
import translationID from './locales/id/translation.json'; // Endonezce
import translationRU from './locales/ru/translation.json'; // Rusça

const resources = {
  en: { translation: translationEN },
  tr: { translation: translationTR },
  ar: { translation: translationAR }, // Arapça eklendi
  de: { translation: translationDE }, // Almanca eklendi
  fr: { translation: translationFR }, // Fransızca eklendi
  id: { translation: translationID }, // Endonezce eklendi
  ru: { translation: translationRU }, // Rusça eklendi
};

i18n
  .use(LanguageDetector) // Tarayıcı dilini algılar
  .use(initReactI18next) // i18n'i react-i18next modülleriyle başlatır
  .init({
    resources,
    fallbackLng: 'en', // Eğer algılanan dil için çeviri yoksa kullanılacak varsayılan dil
    // supportedLngs: ['en', 'tr', 'ar', 'de', 'fr', 'id', 'ru'], // İsteğe bağlı: Desteklenen dilleri açıkça belirtmek için
    interpolation: {
      escapeValue: false, // React zaten XSS koruması yaptığı için gereksiz
    },
    detection: {
      // Dil algılama seçenekleri
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], // Algılanan dili nerede saklayacağı (localStorage önerilir)
    },
  });

export default i18n;